.section {
  display: grid;
  gap: var(--space-3);
  min-width: 0;
}

/*
 * Sections stacked in a page separate themselves. Owning the gap here rather
 * than asking every page to remember a wrapper is what stops the spacing
 * between two groups from being different on two screens.
 */
.section + .section {
  margin-top: var(--space-6);
}

.head {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--space-3);
}

.headings {
  display: grid;
  gap: var(--space-1);
  min-width: 0;
}

/*
 * Faint, small, uppercase and widely tracked. The tracking is not decoration:
 * uppercase at 11px with default tracking is a solid block that has to be
 * decoded letter by letter, and `--tracking-label` is the value the design
 * system already measured for it.
 */
.label {
  font: var(--type-label);
  letter-spacing: var(--tracking-label);
  text-transform: uppercase;
  color: var(--text-faint);
}

.description {
  max-width: var(--content-max);
  font: var(--type-body-sm);
  color: var(--text-muted);
}

.actions {
  display: flex;
  align-items: center;
  gap: var(--space-2);
}

.body {
  display: grid;
  gap: var(--space-3);
  min-width: 0;
}
